import { useId, type ReactNode } from "react";

type NgonLogoProps = {
  className?: string;
  markClassName?: string;
  textClassName?: string;
  showText?: boolean;
  suffix?: ReactNode;
};

export function NgonLogo({
  className = "",
  markClassName = "size-9",
  textClassName = "text-[15px]",
  showText = true,
  suffix,
}: NgonLogoProps) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <NgonMark className={markClassName} />
      {showText ? (
        <span className={`inline-flex items-center gap-1.5 font-bold tracking-[-0.02em] ${textClassName}`}>
          <span>NGON Tech</span>
          {suffix}
        </span>
      ) : null}
    </span>
  );
}

export function NgonMark({ className = "size-9" }: { className?: string }) {
  const rawId = useId().replace(/:/g, "");
  const outerClipId = `ngon-outer-ring-${rawId}`;
  const innerClipId = `ngon-inner-ring-${rawId}`;

  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      role="img"
      aria-label="NGON Tech"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id={outerClipId} clipPathUnits="userSpaceOnUse">
          <path
            d="M20 3h24l17 17v24L44 61H20L3 44V20L20 3Z M24 18h16l6 6v16l-6 6H24l-6-6V24l6-6Z"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </clipPath>
        <clipPath id={innerClipId} clipPathUnits="userSpaceOnUse">
          <path
            d="M27 21h10l6 6v10l-6 6H27l-6-6V27l6-6Z M29 27h6l2 2v6l-2 2h-6l-2-2v-6l2-2Z"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </clipPath>
      </defs>
      <g clipPath={`url(#${outerClipId})`}>
        <rect width="64" height="64" fill="#149CE8" />
        <path d="M3 20 20 3h14l17 17-11-2H24L3 39Z" fill="#0B3F9A" />
        <path d="M34 3h10l17 17v16L46 24 40 18Z" fill="#0877C8" />
        <path d="M61 20v17L46 46V24Z" fill="#159FEF" />
        <path d="M61 36v8L44 61H30l16-21Z" fill="#B8DDF4" />
        <path d="M30 61H20L3 44v-8l21 10Z" fill="#139DEB" />
        <path d="M3 36V20l15 4v16L3 50Z" fill="#0879C4" />
        <path d="M18 40h22l6 6-16 15Z" fill="#24A8EE" />
        <path d="M24 18h16l-6-15 27 33-15-12-6-6Z" fill="#0B64B7" opacity="0.55" />
      </g>
      <g clipPath={`url(#${innerClipId})`}>
        <rect x="20" y="20" width="24" height="24" fill="#159FEF" />
        <path d="M21 27 27 21h9l7 7-8-1h-6l-8 8Z" fill="#BCE5FA" />
        <path d="M36 21h1l6 6v9l-6-7Z" fill="#0B82D5" />
        <path d="M43 33v4l-6 6h-8l8-8Z" fill="#0B3F9A" />
        <path d="M27 43 21 37v-4l8 4h8l-8 6Z" fill="#0A7BC8" />
        <path d="M21 33v-6l8 2v8Z" fill="#159FEF" />
      </g>
    </svg>
  );
}
